// extracted by mini-css-extract-plugin
module.exports = {"product-search-refinement-price-input__input":"ProductSearchRefinementPriceInput_product-search-refinement-price-input__input__U77qf"};